import { API } from "@aws-amplify/api";

const query =`query MyQuery($input: cidInput!) {
  moveChargesService(input: $input) {
    chargesService {
      bolNo
      title
      subTitle
      section {
        subTitle
        title
        dataItems {
          highlight
          hasSubContent
          label
          subText
          value
        }
      }
    }
    moveDetails {
      title
      subTitle
      section {
        dataItems {
          hasSubContent
          label
          subText
          value
        }
      }
    }
    estimateTypeBinding {
      subTitle
      title
      section {
        dataItems {
          hasSubContent
          label
          subText
          value
        }
        rowItems {
          hasSubContent
          label
          subText
          value
        }
      }
    }
  }
}`;

export async function calMoveChargesService(cid: any): Promise<any> {
  try {
    const response: any = await API.graphql({
      query: query, variables: {
        input: {
          customerId: cid
        }
      },
    });
    return response.data.moveChargesService
  } catch (error) {
    console.log("calMoveChargesService", error);
  }
}
